module.exports = __webpack_public_path__ + "img/97rwgj_TC.b018e97a.jpg";